import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';
import { PrimengModule } from 'src/app/primeng/primeng.module';

import {
  MxLazyScrollTableComponent,
  MxTableBodyComponent,
  MxTableCaptionButtonComponent,
  MxTableCaptionComponent,
  MxTableCaptionSplitButtonComponent,
  MxTableCellComponent,
  MxTableColumnChooserComponent,
  MxTableColumnFilterComponent,
  MxTableEmptyMessageComponent,
  MxTableHeaderCellComponent,
  MxTableHeaderComponent,
  MxTableLoadingBodyComponent,
  MxTableOperationButtonComponent,
  MxTableSearchComponent,
} from '.';
import { MxDirectivesModule } from '../../directives/mx.directives.module';
import { MxPipesModule } from '../../pipes/mx.pipes.module';
import { MxDropdownModule } from '../mx.dropdown/mx.dropdown.module';
import { MxMultiSelectModule } from '../mx.multi-select/mx.multi-select.module';
import { MxOverlayPanelModule } from '../mx.overlay-panel/mx.overlay-panel.module';
import { MxSliderModule } from '../mx.slider/mx.slider.module';
import { MxScrollTableComponent } from './mx.scroll-table/mx.scroll-table.component';
import { MxColumnPositionPipe } from './mx.table-cell/mx.column-position.pipe';
import { MxTableOperationsMenuComponent } from './mx.table-mobile-operations-menu/mx.table-mobile-operations-menu.component';
import { MxTableOperationSpeedDialComponent } from './mx.table-operation-speed-dial/mx.table-operation-speed-dial.component';
import {
  MxTableOperationTieredMenuButtonComponent,
} from './mx.table-operation-tiered-menu-button/mx.table-operation-tiered-menu-button.component';

export const COMPONENTS: any[] = [
  MxTableCellComponent,
  MxTableHeaderCellComponent,
  MxTableColumnChooserComponent,
  MxTableCaptionComponent,
  MxTableCaptionSplitButtonComponent,
  MxTableSearchComponent,
  MxTableCaptionButtonComponent,
  MxTableColumnFilterComponent,
  MxTableEmptyMessageComponent,
  MxTableLoadingBodyComponent,
  MxTableBodyComponent,
  MxTableHeaderComponent,
  MxLazyScrollTableComponent,
  MxTableOperationButtonComponent,
  MxTableOperationSpeedDialComponent,
  MxTableOperationTieredMenuButtonComponent,
  MxTableOperationsMenuComponent,
  MxScrollTableComponent
];

const PIPES =[MxColumnPositionPipe]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PrimengModule,
    I18NextModule,
    MxSliderModule,
    MxDropdownModule,
    MxPipesModule,
    MxMultiSelectModule,
    MxDirectivesModule,
    MxOverlayPanelModule
  ],
  declarations: [...COMPONENTS, ...PIPES],
  exports: [...COMPONENTS],
  providers: [...PIPES]
})
export class MxTableModule {}
